<template>
  <main class="html-page home-page about-page">
    <section class="page-hero about-hero" data-bloco="quem-somos-hero" data-tipo="hero">
      <div class="container about-hero-grid">
        <div class="about-hero-copy">
          <p class="eyebrow" data-campo="iti_nome" v-html="html(quemSomosHero, 'iti_nome')"></p>
          <h1 data-campo="iti_resumo1" v-html="html(quemSomosHero, 'iti_resumo1')"></h1>
          <p data-campo="iti_descricao1" v-html="html(quemSomosHero, 'iti_descricao1')"></p>
        </div>
        <div v-if="image(quemSomosHero)" class="about-hero-media">
          <img :src="image(quemSomosHero)" :alt="text(quemSomosHero, 'iti_nome')" data-img="imagem" @error="hideBrokenImage">
        </div>
      </div>
    </section>

    <section class="section" data-bloco="quem-somos-institucional" data-tipo="conteudo">
      <div class="split container">
        <div v-if="institutionalImages.length" class="image-stack">
          <img v-if="institutionalImages[0]" class="main" :src="institutionalImages[0]" :alt="text(quemSomosInstitucional, 'iti_nome')" data-img="imagem" @error="hideBrokenImage">
          <img v-if="institutionalImages[1]" class="mini" :src="institutionalImages[1]" :alt="text(quemSomosInstitucional, 'iti_nome')" data-img="imagem-secundaria" @error="hideBrokenImage">
        </div>
        <div class="split-copy">
          <h2 data-campo="iti_nome" v-html="html(quemSomosInstitucional, 'iti_nome')"></h2>
          <p data-campo="iti_descricao1" v-html="html(quemSomosInstitucional, 'iti_descricao1')"></p>
          <p data-campo="iti_descricao2" v-html="html(quemSomosInstitucional, 'iti_descricao2')"></p>
        </div>
      </div>
    </section>

    <section class="section soft" data-bloco="quem-somos-valores" data-tipo="lista">
      <div class="container values-grid" data-repetidor="valores">
        <article v-for="(item, index) in valores" :key="item.itiId || index" class="info-card" data-item="">
          <h3 data-campo="iti_nome" v-html="html(item, 'iti_nome')"></h3>
          <p data-campo="iti_resumo1" v-html="html(item, 'iti_resumo1')"></p>
        </article>
      </div>
    </section>

    <section class="section" id="equipe">
      <div class="container">
        <div class="section-head" data-bloco="quem-somos-equipe-titulo" data-tipo="conteudo">
          <div>
            <p class="eyebrow" data-campo="iti_nome" v-html="html(equipeTitulo, 'iti_nome')"></p>
            <h2 data-campo="iti_descricao1" v-html="html(equipeTitulo, 'iti_descricao1')"></h2>
          </div>
          <p data-campo="iti_descricao2" v-html="html(equipeTitulo, 'iti_descricao2')"></p>
        </div>
        <div class="team-grid" data-bloco="quem-somos-equipe" data-tipo="lista" data-repetidor="quem-somos-equipe">
          <article v-for="(item, index) in equipe" :key="item.itiId || index" class="team-card" data-item="">
            <img v-if="image(item)" :src="image(item)" :alt="text(item, 'iti_nome')" data-img="imagem" @error="hideBrokenImage">
            <h3 data-campo="iti_nome" v-html="html(item, 'iti_nome')"></h3>
            <strong data-campo="iti_referencia" v-html="html(item, 'iti_referencia')"></strong>
            <p data-campo="iti_resumo1" v-html="html(item, 'iti_resumo1')"></p>
          </article>
        </div>
      </div>
    </section>

    <a class="whatsapp" href="https://wa.me/5551991544590?text=Olá%2C%20gostaria%20de%20informações." aria-label="Falar com a Imaginar pelo WhatsApp"><span aria-hidden="true"></span></a>
  </main>
</template>

<script>
import { contentValue, firstImage, allImages, loadScreens, applyPageMeta } from '@/services/contentApi';

export default {
  name: 'QuemSomosView',
  data() {
    return {
      quemSomosHero: {},
      quemSomosInstitucional: {},
      valores: [],
      equipeTitulo: {},
      equipe: [],
    };
  },
  computed: {
    institutionalImages() {
      return allImages(this.quemSomosInstitucional).slice(0, 2);
    },
  },
  created() {
    this.loadContent();
  },
  methods: {
    text(source, field) { return contentValue(source, field); },
    html(source, field) { return contentValue(source, field); },
    image(source) { return firstImage(source); },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    async loadContent() {
      const data = await loadScreens([
        { ctiId: 15, key: 'quemSomosHero', multi: false },
        { ctiId: 16, key: 'quemSomosInstitucional', multi: false },
        { ctiId: 17, key: 'valores', multi: true },
        { ctiId: 18, key: 'equipeTitulo', multi: false },
        { ctiId: 19, key: 'equipe', multi: true },
      ]);
      Object.assign(this, data);
      applyPageMeta({
        title: contentValue(this.quemSomosHero, 'iti_resumo1') || contentValue(this.quemSomosHero, 'iti_nome'),
        description: contentValue(this.quemSomosHero, 'iti_descricao1'),
        image: firstImage(this.quemSomosHero),
      });
    },
  },
};
</script>
